const mvAnimation = (): void => {
  const svg1: HTMLElement | null = document.querySelector('.js-animation-svg1');
  const svg2: HTMLElement | null = document.querySelector('.js-animation-svg2');
  const svg3: HTMLElement | null = document.querySelector('.js-animation-svg3');
  const svg4: HTMLElement | null = document.querySelector('.js-animation-svg4');
  const svg5: HTMLElement | null = document.querySelector('.js-animation-svg5');
  const svg6: HTMLElement | null = document.querySelector('.js-animation-svg6');
  const svg7: HTMLElement | null = document.querySelector('.js-animation-svg7');
  const svg8: HTMLElement | null = document.querySelector('.js-animation-svg8');
  const svg9: HTMLElement | null = document.querySelector('.js-animation-svg9');
  const svg10: HTMLElement | null = document.querySelector('.js-animation-svg10');

  new Promise<void>((resolve): void => {
    setTimeout(() => {
      resolve();
      svg1?.querySelector('svg')?.classList.add('active');
      svg2?.querySelector('svg')?.classList.add('active');
      svg3?.querySelector('svg')?.classList.add('active');
      svg4?.querySelector('svg')?.classList.add('active');
      svg5?.querySelector('svg')?.classList.add('active');
      svg6?.querySelector('svg')?.classList.add('active');
      svg7?.querySelector('svg')?.classList.add('active');
      svg8?.querySelector('svg')?.classList.add('active');
      svg9?.querySelector('svg')?.classList.add('active');
      svg10?.querySelector('svg')?.classList.add('active');
    }, 300);
  });
};

export default mvAnimation;
